define('SuiteDynamics.HeelAssistItemSwap.CartHooks.ItemSwap.View', [
	'Backbone',
	'jQuery',
	'underscore',
	'Utils',
	'LiveOrder.Model',
	'suitedynamics_heelassistitemswap_carthooks_itemswap.tpl'
], function ItemSwapView(
	Backbone,
	jQuery,
	_,
	Utils,
	LiveOrderModel,
	tpl
)
{
	'use strict';

	var SERVICE_URL = Utils.getAbsoluteUrl(
		getExtensionAssetsPath('services/SuiteDynamics.HeelAssistItemSwap.CartHooks.Service.ss')
	);

	return Backbone.View.extend({
		template: tpl,

		attributes: {
			id: 'ItemSwapView',
			class: 'ItemSwapView'
		},

		events: {
			'click [data-action="itemswap-close"]': 'handleCloseModalClick'
		},

		initialize: function (options) {
			this.containerComponent = options.container;
			this.cartComponent = this.containerComponent.getComponent('Cart');

			this.viewState = {
				status: 'processing',
				summaryPayload: null,
				errorMessage: ''
			};

			this._collectTargetsAndStartSwap();
		},
		
		_collectTargetsAndStartSwap: function () {
			var self = this;

			this.cartComponent.getLines().then(function (cartLines) {
				var legacyTargets = [];

				_.each(cartLines || [], function (line) {
					var item = line && line.item;
					if (!item) return;

					var raw = (item.extras && item.extras.custitem97) || item.custitem97;
					var isLegacy = (raw === true || raw === 'T');
					var sku = item && item.itemid;
					var orderitemid = line && line.internalid;

					if (isLegacy && sku && orderitemid) {
						legacyTargets.push({
							orderitemid: String(orderitemid),
							sku: String(sku)
						});
					}
				});

				self._performSwap(legacyTargets);
			});
		},

		_performSwap: function (legacyTargets) {
			var self = this;

			this.viewState.status = 'processing';
			this.render();

			jQuery.ajax({
				url: SERVICE_URL,
				type: 'POST',
				contentType: 'application/json',
				data: JSON.stringify({
					action: 'detect_or_swap',
					legacyTargets: legacyTargets
				})
			})
				.then(function (resp) {
					return LiveOrderModel.getInstance().fetch().always(function () {
						if (resp && resp.isError) {
							self.viewState.status = 'error';
							self.viewState.errorMessage =
								resp.errorMessage || 'Unexpected error performing the swap.';
						} else {
							self.viewState.status = 'done';
							self.viewState.summaryPayload = resp || {};
						}
						self.render();
					});
				})
				.fail(function (xhr) {
					var msg =
						(xhr && xhr.responseJSON && xhr.responseJSON.errorMessage) ||
						(xhr && xhr.responseText) ||
						'Unexpected error performing the swap.';
					self.viewState.status = 'error';
					self.viewState.errorMessage = msg;
					self.render();
				});
		},

		handleCloseModalClick: function (e) {
			e && e.preventDefault();
			if (this.$containerModal) {
				this.$containerModal
					.removeClass('fade')
					.modal('hide')
					.data('bs.modal', null);
			}
		},

		getContext: function () {
			var summary = this.viewState.summaryPayload || {};
			var updatedPairs = summary.updatedPairs || [];

			return {
				isProcessing: this.viewState.status === 'processing',
				isDone: this.viewState.status === 'done',
				isError: this.viewState.status === 'error',
				updatedPairs: updatedPairs,
				errorMessage: this.viewState.errorMessage,
				updatedPairsNotEmpty: updatedPairs.length > 0
			};
		}
	});
});
